import { createApp } from 'vue';
import AppToast, { type Toast, type ToastConfig } from '@/components/Toasts.vue';

const defaultOptions = {
  timeout: 4000,
  buttons: ['Ok'],
  type: 'info',
} satisfies NonNullableObject<ToastConfig>;

const toastsApp = createApp(AppToast);
const toastsVm = toastsApp.mount('#toast-container') as InstanceType<typeof AppToast>;

let toastID = 0;

const toaster = {
  show: (message: Toast['message'], options: ToastConfig = {}) => {
    const id = ++toastID;
    const config = {
      ...defaultOptions,
      ...options,
    };

    return {
      close: () => toastsVm.removeToast(id),
      /**
       * onClose is a `Promise` that is resolved by `toastsVm.removeToast`
       * whenever the toast's timeout has expired.
       * The code below may look weird, but `toastsVm.addToast` initialized
       * the setTimeout, which is why we need to pass the `Promise` resolver
       * here.
       */
      onClose: new Promise((resolve) => {
        toastsVm.addToast(message, id, resolve, config);
      }),
    };
  },

  success: (message: Toast['message'], options: ToastConfig = {}) => {
    return toaster.show(message, {
      ...options,
      type: 'success',
    });
  },

  info: (message: Toast['message'], options: ToastConfig = {}) => {
    return toaster.show(message, {
      ...options,
      type: 'info',
      timeout: 7000, // Show for at least 7 seconds
    });
  },

  warn: (message: Toast['message'], options: ToastConfig = {}) => {
    return toaster.show(message, {
      ...options,
      type: 'warn',
      timeout: 7000, // Show for at least 7 seconds
    });
  },

  error: (message: Toast['message'], options: ToastConfig = {}) => {
    return toaster.show(message, {
      ...options,
      type: 'error',
      timeout: 0, // Show until clicked
    });
  },
};

export function useToaster () {
  return toaster;
}

// eslint-disable-next-line @stylistic/max-len
export const contactUsMessage = `Als dit blijft voorkomen, <a href="mailto:beweging@groenlinks.nl" class="link">breng ons dan op de hoogte</a>.`;
